import { FC, useEffect, useState } from 'react';
import {
  camelize,
  CurrentIp,
  currentIp as fetchCurrentIp,
} from '@repo-level/core-front';

import { BLACK_LIST_IPS, NOT_ALLOWED_COUNTRIES } from 'helpers/conf';
import { NotAllowedCountry } from 'components/internal/NotAllowedCountry';
import { checkIpInRange } from 'helpers/common';
import { useFranceLocale } from 'hooks/franceLocale';

const checkIP = checkIpInRange(BLACK_LIST_IPS);

export const Restricted: FC = ({ children }) => {
  const [blockService, setBlockService] = useState<boolean>();
  const [currentCode, setCurrentCode] = useState<string>('');

  const { isRestricted } = useFranceLocale();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: currentIp } = await fetchCurrentIp()
          .then(({ data }) => ({ data: JSON.parse(data) }))
          .then(({ data }) => ({ data: camelize(data) as CurrentIp }));

        if (
          currentIp.countryCode in NOT_ALLOWED_COUNTRIES ||
          checkIP(currentIp.ip)
        ) {
          setBlockService(true);
          setCurrentCode(currentIp.countryCode);
          return;
        }

        setBlockService(false);
        setCurrentCode(currentIp.countryCode);
      } catch {}
    };

    fetchData();
  }, []);

  if (blockService == null) return null;

  if (blockService || isRestricted) {
    return <NotAllowedCountry countryCode={currentCode} />;
  }

  return <>{children}</>;
};
